/*
 * OpenAppBanner Messages
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.OpenAppBanner';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'KAMEREO - Nhập hàng Doanh nghiệp',
  },
  subtitle: {
    id: `${scope}.subtitle`,
    defaultMessage: 'Đặt hàng nhanh, tiện lợi',
  },
  useApp: {
    id: `${scope}.useApp`,
    defaultMessage: 'Mở App',
  },
  popupTitle: {
    id: `${scope}.popupTitle`,
    defaultMessage: 'Mở trang này trong app Kamereo?',
  },
  popupCancel: {
    id: `${scope}.popupCancel`,
    defaultMessage: 'Hủy',
  },
  popupOpen: {
    id: `${scope}.popupOpen`,
    defaultMessage: 'Mở',
  },
});
